$(document).ready(function(){
  $(".need_a_diff, .close").click(function(){
    $(".u_modal").toggle();
  });
  
  let final = "";
  let comb = "";
  $(".ms_product_radio_input:checked").each(function(){
    let checked_val = $(this).val();
    comb += checked_val + " / "
  })
  var finall = comb.slice(0 ,comb.length-2).trim();

  let flag = false;
  $(".ms_master_select option").each(function(){
    var word = $(this).attr("data-title").trim();
    if(word == finall){
      flag = true;
    }
  });
  let final1 = "";
  let comb1 = "";
  $(".ms_product_radio_input:checked").each(function(){
    let checked_val = $(this).val();
    comb1 += checked_val + " / "
  })
  var finall1 = comb1.slice(0 ,comb1.length-2).trim();
  $(".ms_master_select option").each(function(){
    let master = $(this);
    let master_val = $(this).attr("data-title").trim();
    let master_var_id = $(this).attr("var-id");
    let master_var_qty = $(this).attr("data-iq");
    let var_policy = $(this).attr("var-policy");
    let var_manag = $(this).attr("var-manag");
  })
  if(flag==true){
    //master select
    $(".ms_master_select option").each(function(){
      var testingV = $(this).attr("data-title").trim();
      if($(this).attr("data-title").trim() == finall){
        $(".ms_master_select").val($(this).val()).trigger("change");
        let var_title = $(this).attr("data-title");
        let var_suit_size = $(this).attr("data-option-without-pant-size");
        let var_pant_size = $(this).attr("data-pant");
        let var_policy = $(this).attr("var-policy")
        let var_manag = $(this).attr("var-manag")
        let var_qty = parseInt($(this).attr("data-iq"));
        if(var_policy == "deny" && var_manag == "shopify"){
          if(var_qty > 0){
            console.log("quantity > 0")
            $(".ms_option_selected").text(var_title);
            $(".ms_jacket_size").text(var_suit_size);
            $(".ms_pant_size").text(var_pant_size);
          }
          else{
            console.log("quantity < 0")
            $(".ms_option_selected").text(var_title);
            $(".ms_jacket_size").text(var_suit_size);
            $(".ms_pant_size").text(var_pant_size);
          }
        }
        else{
          console.log("quantity < 0 and contimue")
          $(".ms_option_selected").text(var_title);
          $(".ms_jacket_size").text(var_suit_size);
          $(".ms_pant_size").text(var_pant_size);
        }
      }
    });
  }
  else{
    $(".ms_option_selected").text("Unavailable")
  }

  $(".ms_product_radio_input").change(function(){
    let combination = "";
    let suitTitle = "";
    let jacketSize = "";
    let pantSize = "";
    let suitPolicy = "";
    let suitManage = "";
    let suitQty = "";
    $(".ms_product_radio_input:checked").each(function(){
      let selectedVal = $(this).val();
      combination += selectedVal + " / "
    })

    final_selectedVal = combination.substring(0,combination.length - 3).trim();
    console.log("final_selectedVal", final_selectedVal);

    $(".ms_master_select option").each(function(){
      if ($(this).text().trim() == final_selectedVal ){
        $(".ms_master_select").val($(this).val()).trigger("change");
        let suitTitle = $(this).attr("data-title");
        let jacketSize = $(this).attr("data-option-without-pant-size");
        let pantSize = $(this).attr("data-pant");
        let suitPolicy = $(this).attr("var-policy");
        let suitManage = $(this).attr("var-manag");
        let suitQty = parseInt($(this).attr("data-iq"));
        if(suitPolicy == "deny" && suitManage == "shopify"){
          if(suitQty > 0){
            console.log("quantity > 0")
            $(".ms_option_selected").text(suitTitle);
            $(".ms_jacket_size").text(jacketSize);
            $(".ms_pant_size").text(pantSize);
          }
          else{
            console.log("quantity < 0")
            $(".ms_option_selected").text(suitTitle);
            $(".ms_jacket_size").text(jacketSize);
            $(".ms_pant_size").text(pantSize);
          }
        }
        else{
          console.log("quantity < 0 and contimue")
          $(".ms_option_selected").text(suitTitle);
          $(".ms_jacket_size").text(jacketSize);
          $(".ms_pant_size").text(pantSize);
        }
      }
    });
    
  })

  $(".ms_product_wish").click(function(){
    console.log("wish click");
    $(this).parents(".product__page").find(".wk-button").trigger("click");
  });


     $(document).on("click",".wk-button",function() {
        $(".ms_product_wish").toggleClass("fill_heart");
        });

   setTimeout(function() { 
  if($(".wk-button").hasClass("wk-selected")){
    $(".ms_product_wish").addClass("fill_heart");
  } else{
    console.log("Class not found");
  }
     }, 4000);
  
});
/* ──────────────────────────────────────────────────────────────────────
   MS variant selector enhancements:
     1. Grey out jacket sizes whose recommended pant sizes are all OOS
     2. Hide non-recommended pant sizes once a jacket is selected
     3. "Sold Out" tooltip on any greyed-out size
   ────────────────────────────────────────────────────────────────────── */
(function() {
  'use strict';

  var sizeCompatibility = {
    '34': [28, 30], '36': [28, 30, 32], '38': [30, 32, 34],
    '40': [32, 34, 36], '42': [34, 36, 38], '44': [36, 38, 40],
    '46': [38, 40, 42], '48': [40, 42, 44], '50': [42, 44, 46],
    '52': [44, 46, 48], '54': [46, 48, 50], '56': [48, 50, 52],
    '58': [50, 52, 54], '60': [52, 54]
  };

  var DISABLED_STYLE_PROPS = ['opacity','cursor','background-color','color','border-color'];
  var SOLDOUT_LABEL = 'Sold Out';

  function buildLookup() {
    var json = document.getElementById('ms-variant-json');
    if (!json) return null;
    var data;
    try { data = JSON.parse(json.textContent); } catch (e) { return null; }
    var lookup = {};
    data.variants.forEach(function(v) {
      if (!lookup[v.option1]) lookup[v.option1] = {};
      lookup[v.option1][parseInt(v.option2)] = v.available;
    });
    return lookup;
  }

  function jacketHasInStockRecommended(jSize, lookup) {
    var recommended = sizeCompatibility[jSize] || [];
    if (recommended.length === 0) return true;
    var jLookup = lookup[jSize] || {};
    for (var i = 0; i < recommended.length; i++) {
      if (jLookup[recommended[i]] === true) return true;
    }
    return false;
  }

  function applyDisabledInlineStyle(label) {
    if (!label) return;
    label.style.setProperty('opacity', '0.45', 'important');
    label.style.setProperty('cursor', 'not-allowed', 'important');
    label.style.setProperty('background-color', 'var(--COLOR-A5)', 'important');
    label.style.setProperty('color', 'var(--COLOR-A20)', 'important');
    label.style.setProperty('border-color', 'var(--COLOR-A20)', 'important');
  }

  function clearDisabledInlineStyle(label) {
    if (!label) return;
    DISABLED_STYLE_PROPS.forEach(function(prop) { label.style.removeProperty(prop); });
    label.style.removeProperty('pointer-events');
  }

  function applyJacketOOS(lookup) {
    if (!lookup) return;
    var fieldset = document.querySelector('.radio__fieldset:has(input[name*="Jacket Size"])');
    if (!fieldset) return;
    var buttons = fieldset.querySelectorAll('.radio__button');
    buttons.forEach(function(button) {
      var input = button.querySelector('input');
      if (!input) return;
      var label = button.querySelector('label');
      if (button.style.display === 'none') {
        if (label) clearDisabledInlineStyle(label);
        return;
      }
      var jSize = input.value;
      var recommendedOOS = !jacketHasInStockRecommended(jSize, lookup);
      var themeUnavailable = input.classList.contains('unavailable');
      var shouldDisable = recommendedOOS || themeUnavailable;

      if (shouldDisable) {
        input.disabled = true;
        input.classList.add('unavailable');
        if (label) {
          label.classList.add('ms-jacket-soldout');
          if (label.title !== SOLDOUT_LABEL) label.title = SOLDOUT_LABEL;
          applyDisabledInlineStyle(label);
        }
        if (input.checked) input.checked = false;
      } else {
        if (label) {
          if (label.classList.contains('ms-jacket-soldout')) {
            label.classList.remove('ms-jacket-soldout');
          }
          if (label.title === SOLDOUT_LABEL || label.title === 'Out of stock') {
            label.title = '';
          }
          clearDisabledInlineStyle(label);
        }
      }
    });
  }

  function getPantButtons() {
    var fs = document.querySelector('.radio__fieldset:has(input[name*="Pant Size"])');
    return fs ? fs.querySelectorAll('.radio__button') : [];
  }

  function showAllPants() {
    var buttons = getPantButtons();
    buttons.forEach(function(button) {
      if (button.style.display !== '') button.style.display = '';
      var input = button.querySelector('input');
      if (input && input.disabled) input.disabled = false;
    });
    normalizePantTooltips();
  }

  function filterPantsToRecommended(jSize) {
    if (!jSize) return;
    var recommended = sizeCompatibility[jSize];
    if (!recommended || recommended.length === 0) {
      normalizePantTooltips();
      return;
    }
    var allowed = {};
    recommended.forEach(function(p) { allowed[String(p)] = true; });
    var buttons = getPantButtons();
    buttons.forEach(function(button) {
      var input = button.querySelector('input');
      if (!input) return;
      if (allowed[input.value]) {
        if (button.style.display !== '') button.style.display = '';
        if (input.disabled) input.disabled = false;
      } else {
        if (button.style.display !== 'none') button.style.display = 'none';
        if (!input.disabled) input.disabled = true;
        if (input.checked) input.checked = false;
      }
    });
    normalizePantTooltips();
  }

  function normalizePantTooltips() {
    var buttons = getPantButtons();
    buttons.forEach(function(button) {
      var label = button.querySelector('label');
      if (!label) return;
      var desired;
      if (label.classList.contains('ms-pant-soldout')) {
        desired = SOLDOUT_LABEL;
      } else if (label.title === 'Out of stock' || label.title === SOLDOUT_LABEL) {
        desired = '';
      } else {
        return;
      }
      if (label.title !== desired) label.title = desired;
    });
  }

  function getSelectedJacket() {
    var sel = document.querySelector('.radio__fieldset:has(input[name*="Jacket Size"]) input.ms_product_radio_input:checked');
    return sel ? sel.value : null;
  }

  function evaluatePants() {
    var jSize = getSelectedJacket();
    if (jSize) {
      filterPantsToRecommended(jSize);
    } else {
      showAllPants();
    }
  }

  function init() {
    if (!document.getElementById('ms-variant-json')) return;
    var lookup = buildLookup();
    if (!lookup) return;

    var pendingJacket = false;
    function runJacket() {
      if (pendingJacket) return;
      pendingJacket = true;
      requestAnimationFrame(function() {
        pendingJacket = false;
        applyJacketOOS(lookup);
      });
    }
    var pendingPants = false;
    function runPants() {
      if (pendingPants) return;
      pendingPants = true;
      requestAnimationFrame(function() {
        pendingPants = false;
        evaluatePants();
      });
    }

    runJacket();
    runPants();

    var jacketFieldset = document.querySelector('.radio__fieldset:has(input[name*="Jacket Size"])');
    if (jacketFieldset) {
      new MutationObserver(runJacket).observe(jacketFieldset, {
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'disabled', 'class']
      });
    }

    var pantFieldset = document.querySelector('.radio__fieldset:has(input[name*="Pant Size"])');
    if (pantFieldset) {
      new MutationObserver(runPants).observe(pantFieldset, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'title', 'style', 'disabled']
      });
    }

    document.addEventListener('change', function(e) {
      if (!e.target) return;
      if (e.target.name === 'properties[Fit]' || e.target.name === 'properties[Jacket Length]') {
        requestAnimationFrame(runJacket);
        setTimeout(runJacket, 50);
        setTimeout(runJacket, 250);
        setTimeout(runPants, 60);
        setTimeout(runPants, 260);
        return;
      }
      if (e.target.matches && e.target.matches('.radio__fieldset:has(input[name*="Jacket Size"]) input.ms_product_radio_input')) {
        setTimeout(runPants, 60);
        setTimeout(runPants, 260);
        return;
      }
    });

    document.addEventListener('click', function(e) {
      if (e.target && e.target.classList && e.target.classList.contains('ms-step-edit-btn')) {
        setTimeout(runPants, 60);
        setTimeout(runPants, 260);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();